import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const FeedbackLogin = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-lg p-4 mb-4 shadow grid gap-2">
      <p>Envie de proposer une nouvelle fonctionnalité, une amélioration ou signaler un bug ? Ou simplement voter pour des propositions déjà existantes ?</p>
      
      <p>Identifie-toi ou crée un compte ! ⬇️</p>
      
      <div>
        <button
            className="bg-blue-100 hover:bg-blue-200 text-white px-4 py-2 rounded"
            onClick={() => navigate("/login?redirect=feedbacks")}
        >
            Se connecter ou créer un compte
        </button>
      </div>
    </div>
  );
};

export default FeedbackLogin;